<div class="iframeFix" *ngIf="fix"></div>
<iframe
  *ngIf="sourceType === 'youtube'"
  class="embed-video"
  width="{{ width }}"
  height="{{ height }}"
  [src]="source | safe"
  frameborder="0"
  allowfullscreen></iframe>
<iframe
  *ngIf="sourceType === 'vimeo'"
  class="embed-video"
  width="{{ width }}"
  height="{{ height }}"
  [src]="source | safe"
  frameborder="0"
  webkitallowfullscreen
  mozallowfullscreen
  allowfullscreen></iframe>
